export default {"src":"/_next/static/media/briefcase_color.72a6774b.svg","height":32,"width":32};